import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolAdminService } from "../../services/schooladmin.service";
import * as moment from "moment";

@Component({
	selector: "app-view-trigger",
	templateUrl: "./view-trigger.component.html",
	styleUrls: ["./view-trigger.component.css"],
})
export class ViewTriggerComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig, private schoolAdminService: SchoolAdminService) {}

	ngOnInit(): void {
		//Load data from Parent
		this.SelectedTrigger = this.dialogConfig.data.SelectedTrigger;

		//Load data from DB
		this.loadTriggerData();
	}

	/////////////////////////////
	// Data
	/////////////////////////////
	//Input Data
	SelectedTrigger: any = null;
	TriggerData: any = {
		ActionTriggerID: "",
		ActionTriggerType: "",
		TriggerOccursWhen: "",
		TriggerResults: "",
		TriggerReset: "",
		TriggerAdmin: "",
		CreateDT: "",
	};

	//Output Data
	TriggerType: String = "";
	OccursWhen: String = "";
	ResultsIn: String = "";
	ResetCond: String = "";
	CreatedBy: String = "";
	CreatedOn: String = "";
	/////////////////////////////

	/////////////////////////////
	// Load Data
	/////////////////////////////
	loadTriggerData() {
		var result = this.schoolAdminService.ActionTriggerDetailsGetList("", this.SelectedTrigger.ActionTriggerID);
		result.subscribe(
			(response) => {
				this.TriggerData = response;

				this.UpdateData();
			},
			(error) => {}
		);
	}

	UpdateData() {
		this.TriggerType = this.TriggerData[0].ActionTriggerType;
		this.OccursWhen = this.TriggerData[0].TriggerOccursWhen;
		this.ResultsIn = this.TriggerData[0].TriggerResults;
		this.ResetCond = this.TriggerData[0].TriggerReset;
		this.CreatedBy = this.TriggerData[0].TriggerAdmin;
		this.CreatedOn = moment(new Date(this.TriggerData[0].CreateDT)).format("MM/DD/YYYY h:mm A");
	}

	/////////////////////////////

	/////////////////////////////
	// Buttons
	/////////////////////////////
	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////
}
